export default "__VITE_ASSET__De1Mux9W__"